import React, { useEffect, useState } from "react";
import "./onlinePendingLogsMain.scss";
import {
  PENDING_HEADER_LIST_TITLE,
  PENDING_HEADER_LIST,
  APPLICABLE_ROLE,
  API_FILTER_LIST,
} from "../../constant";
import { ClickAwayListener } from "@material-ui/core";
import FilterMenuList from "../../../common/Modules/FilterMenuList";
import { USER_ROLE } from "../../../../Util/constants";

export const OnlinePendingLogsMainView = ({
  doctorRole,
  user_type,
  params,
  headerData,
  applyParams,
}) => {
  const [data, setData] = useState();
  const [clonedArray, setCloneArray] = useState();

  useEffect(() => {
    let clonedArrayData = headerData.map((a) => {
      return { ...a };
    });
    setCloneArray(clonedArrayData);
    setData(headerData);
  }, [headerData]);

  const getClassName = (obj) => {
    let name = "col-md-2";

    if (obj.title === PENDING_HEADER_LIST_TITLE.DATETIME) {
      name = "col-md-2 pl-0 d-flex ";
    } else if (obj.title === PENDING_HEADER_LIST_TITLE.DOCTORNAME) {
      name = "col-md-2 p-0 d-flex";
    } else if (obj.title === PENDING_HEADER_LIST_TITLE.PATIENTDETAILS) {
      name = "col-md-2 p-0";
    } else if (obj.title === PENDING_HEADER_LIST_TITLE.PROCEDURE) {
      name = "col-md-2  p-0";
    } else if (obj.title === PENDING_HEADER_LIST_TITLE.PAYMENTMETHOD) {
      name = "col-md-2 p-0";
    } else if (
      obj.title === "" ||
      obj.title === PENDING_HEADER_LIST_TITLE.STATUS
    ) {
      name =
        user_type === APPLICABLE_ROLE.STAFF ||
          doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN
          ? "col-md-1 d-flex p-0"
          : "col-md-2 d-flex p-0";
    } else if (obj.title === PENDING_HEADER_LIST_TITLE.ACTION) {
      name =
        user_type === APPLICABLE_ROLE.STAFF ||
          doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN
          ? "col-md-1 text-right"
          : "col-md-2";
    }

    return name;
  };

  const onFilterClick = (obj) => {
    let dataCopy = [...data];
    let ind = clonedArray.findIndex((ele) => ele.title === obj.title);
    dataCopy.forEach((header) => {
      if (header.title === obj.title) {
        obj.show_filter = true;
        obj.menuData = clonedArray[ind].menuData;
      }
    });

    setData(dataCopy);
  };

  const handleFilterSearch = (key, obj) => {
    let dataDuplicate = [...data];
    let ind = clonedArray.findIndex((ele) => ele.title === obj.title);
    dataDuplicate.forEach((da) => {
      if (da.title === obj.title) {
        let filteredItems = clonedArray[ind].menuData.filter(
          (filterSearchData) =>
            filterSearchData.name?.toLowerCase().includes(key.toLowerCase())
        );
        obj.menuData = filteredItems.length > 0 ? filteredItems : [];
      }
    });
    if (key.length > 0) {
      setData(dataDuplicate);
    } else {
      let filterDataCopy = [...data];
      let original_menu_data = clonedArray.filter((da) => {
        if (obj.title === da.title) {
          return da.menuData;
        }
      });
      filterDataCopy.forEach((da) => {
        if (da.title === obj.title) {
          obj.menuData = original_menu_data[0].menuData;
        }
      });
      setData(filterDataCopy);
    }
  };

  const updateMenuData = (dataArray, obj, item) => {
    dataArray.forEach((da) => {
      if (da.title === obj.title) {
        da.menuData.forEach((menu) => {
          menu.selected = menu.id === item.id;
        });
        da.show_filter = false;
      }
    });
  };

  const toggleItems = (item, obj) => {
    const dataCopy = [...data];
    const clonedArrayCopy = [...clonedArray];

    updateMenuData(dataCopy, obj, item);
    updateMenuData(clonedArrayCopy, obj, item);

    setCloneArray(clonedArrayCopy);
    setData(dataCopy);
    handleApplyFilter();
  };

  const handleApplyFilter = () => {
    let obj = { ...params };
    let allSelectedDate = {};
    let selectedValue = headerData;
    selectedValue.forEach((filterData) => {
      allSelectedDate = getSelectedData(filterData?.mobileFilterTitle);
      obj = { ...obj, ...allSelectedDate };
    });
    applyParams({ ...obj, [API_FILTER_LIST.PAGENO]: 1 });
  };

  const getSelectedData = (filterName) => {
    let headerSelectedData = headerData;
    let index = headerSelectedData.findIndex(
      (filterselectedData) => filterselectedData?.mobileFilterTitle === filterName
    );
    let selectedData = headerData[index]?.menuData?.find(
      (val) => val.selected === true
    );
    switch (filterName) {
      case "DOCTOR NAME":
        return {
          doctor_id:
            selectedData?.value === "all"
              ? selectedData?.doctor_id
              : [selectedData?.id],
        };
      case "STATUS":
        return {
          status_filter:
            selectedData?.value === "all" ? "" : selectedData?.value,
        };
      default:
        return {};
    }
  };

  const hideFilter = (obj) => {
    let dataCopy = [...data];
    dataCopy.forEach((header) => {
      if (header.title === obj.title) {
        obj.show_filter = false;
      }
    });
    setData(dataCopy);
  };

  const renderFilter = (obj) => {
    return (
      obj.filter_icon && (
        <div
          className="mx-1"
          style={{
            position: "relative",
          }}
        >
          <img
            onClick={() => onFilterClick(obj)}
            src={obj.filter_icon}
            alt=""
            style={{ cursor: "pointer" }}
          />
          {obj.show_filter && obj.filter_type === "normal" && (
            <ClickAwayListener onClickAway={() => hideFilter(obj)}>
              <div className={`view-logs-header-filter`}>
                <div>
                  <FilterMenuList
                    menuItemList={obj.menuData}
                    show_filter_searchbar={obj.show_search}
                    handleFilterSearch={(key) => handleFilterSearch(key, obj)}
                    toggleItems={(item) => toggleItems(item, obj)}
                    placeholderForSearch={obj.placeholder}
                  />
                </div>
              </div>
            </ClickAwayListener>
          )}
        </div>
      )
    );
  };

  const createHeaderUI = (obj, ind) => {
    if (
      user_type === APPLICABLE_ROLE.STAFF ||
      doctorRole === USER_ROLE.DOCTOR_ADMIN ||
      doctorRole === USER_ROLE.RESOURCE_ADMIN
    ) {
      return (
        <div key={ind} className={getClassName(obj)}>
          <span style={{ marginRight: 5 }}>{obj.title}</span>
          {renderFilter(obj)}
        </div>
      );
    }
    if (obj.title === PENDING_HEADER_LIST_TITLE.DOCTORNAME) {
      return;
    }
    return (
      <div key={ind} className={getClassName(obj)}>
        <span style={{ marginRight: 5 }}>{obj.title}</span>
        {renderFilter(obj)}
      </div>
    );
  };

  const createFilterUI = () => {
    return (
      <>
        <div className="row online-pending-log-main-header mt-3 mb-2 d-none d-lg-flex mx-1">
          {PENDING_HEADER_LIST.map((obj, ind) => createHeaderUI(obj, ind))}
        </div>
      </>
    );
  };

  return (
    <div className="online-pending-log-main">
      <>{createFilterUI()}</>
    </div>
  );
};

export default OnlinePendingLogsMainView;
